// IE를 위한 폴리필
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './polyfill';

// Vendors
import 'bootstrap';

import Controller from './controller';
import LayoutView from './view/LayoutView';
// import ScrollerView from './view/ScrollerView';

const layoutView = new LayoutView('body');
// const scrollerView = new ScrollerView('.scroller');

/**
 * @type {Controller}
 */
const controller = new Controller(layoutView);

const setView = () => controller.setView();
window.addEventListener('DOMContentLoaded', setView);
const resizeView = () => controller.resizeView();
window.addEventListener('resize', resizeView);
